"use client";

import { createSafeContext } from "@/common/helpers/react";

export const [IsClientContext, useIsClient] = createSafeContext<boolean>(
  "useIsClient must be used within a IsClientProvider",
);
